import { render, staticRenderFns } from "./emailPreferenceReasonForm.vue?vue&type=template&id=3c351143&scoped=true&"
import script from "./emailPreferenceReasonForm.vue?vue&type=script&lang=ts&"
export * from "./emailPreferenceReasonForm.vue?vue&type=script&lang=ts&"
import style0 from "./emailPreferenceReasonForm.vue?vue&type=style&index=0&id=3c351143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c351143",
  null
  
)

export default component.exports